import styled from 'styled-components';
export const StyledFooterOdds = styled.div`
  background-color: ${(props) => props.theme.footerOdds_BG} !important;
  color: ${(props) => props.theme.footerOdds_text} !important;
`;

export const StyledFooterBonus = styled.div`
  background-color: ${(props) => props.theme.footerBonus_BG} !important;
  color: ${(props) => props.theme.footerBonus_text} !important;
`;

export const StyledbetSlipBtn = styled.button`
  background-color: ${(props) => props.selected ? props.theme.betslipBtnSelected_BG : props.theme.betslipBtn_BG} !important;
  border: 1px solid ${(props) => props.selected ? props.theme.betslipBtnSelected_border : props.theme.betslipBtn_borde} !important;
  color: ${(props) => props.selected ? props.theme.betslipBtnSelected_text : props.theme.betslipBtn_text} !important;
`;

export const StyledbetSlipBtnCount = styled.span`
  background-color: ${(props) => props.selected ? props.theme.betslipBtnCountSelected_BG : props.theme.betslipBtnCount_BG} !important;
  border: 1px solid ${(props) => props.selected ? props.theme.betslipBtnCountSelected_border : props.theme.betslipBtnCount_border} !important;
  color: ${(props) => props.selected ? props.theme.betslipBtnCountSelected_text : props.theme.betslipBtnCount_text} !important;
`;